import { z } from "zod";
import { t } from "./types";
import { DrivingLicenseClassEnum } from "./DrivingLicenseClass";

export const SignatureRequestTypeEnum = z.preprocess(
  // Ensure we can read old data ...
  (val) => {
    if (val === "teilnahmebescheinigung") return "b196_teilnahmebescheinigung";
    return val;
  },
  z.enum([
    "ausbildungsnachweis",
    "schaltnachweis",
    "asf_teilnahmebescheinigung",
    "b196_teilnahmebescheinigung",
    "b96_teilnahmebescheinigung",
  ]),
);
export type SignatureRequestType = z.infer<typeof SignatureRequestTypeEnum>;

export const SignatureRequestStateEnum = z.preprocess(
  // Ensure we can read old data ...
  (val) => {
    if (val === "pending") return "signedByInstructor";
    if (val === "completed") return "signedByInstructorAndStudent";
    return val;
  },
  z.enum(["notSigned", "signedByInstructor", "signedByInstructorAndStudent"]),
);
export type SignatureRequestState = z.infer<typeof SignatureRequestStateEnum>;

export const SignatureRequestSchema = t.object({
  uid: t.string().nonempty(),
  assignedDrivingSchoolManagerId: t.string().nullish(),
  createdAt: t.dateTime().nullish(),
  bookedTrainingId: t.string().nullish(),
  instructorUid: t.string().nullish(),
  studentUid: t.string().nonempty(),
  instructorSignatureCity: t.string(),
  instructorSignedAt: t.dateTime(),
  instructorSignatureStorageRef: t.string(),
  previewStorageRef: t.string(),
  type: SignatureRequestTypeEnum,
  state: SignatureRequestStateEnum,
  studentSignatureCity: t.string().optional(),
  studentSignedAt: t.dateTime().optional(),
  signedDocumentStorageRef: t.string().nullish(),
  signedDocumentSize: t.number().nullish(),
  deleted: t.optional(t.boolean()).default(false),
  deletedAt: t.optional(t.dateTime()),
  deletedById: t.optional(t.string().nonempty()),
  drivingLicenseClass: t.optional(DrivingLicenseClassEnum),
  dataSnapshot: t.optional(t.string().nonempty()),
});

export type SignatureRequest = z.infer<typeof SignatureRequestSchema>;
